
<template>
    <tr :class="hasDiffs ? 'has-diffs' : ''">
        <td v-if="!isLockedForEdit" style="vertical-align: middle; padding-left: 5px; padding-right: 5px; max-width: 20px;">
            <i class="fas fa-trash text-danger pointer" @click="deleteItem"></i>
        </td>

        <td v-if="showSyncButton" style="vertical-align: middle; max-width: 150px;" class="p-0">
            <button v-if="!item.relatedExepense"
                type="button"
                class="btn btn-primary btn-sm small-text m-0 p-0"
                @click.stop="$emit('addExpense', item)">
                Генерирай разход
            </button>
            <button v-if="item.relatedExepense && hasDiffs"
                type="button"
                class="btn btn-primary btn-sm small-text m-0 p-0"
                @click.stop="$emit('updateExpense', item)">
                Обнови разход
            </button>
        </td>
        <td :class="showFileUpload ? 'minWidth-200' : 'minWidth-300'" style="max-width: 400px; vertical-align: middle;">
            <span style="font-size: 0.8rem;">
                {{ item.groupName }}
            </span>
        </td>
        <td :class="showFileUpload ? 'minWidth-500' : 'minWidth-600'" style="vertical-align: middle;">
            <div v-if="!isLockedForEdit">
                <dynamic-dropdown
                    api-url="/api/Tariffs/GetTariffItems"
                    v-model="item.tariffEntityToTariffItemId"
                    :items-from-parent="tariffOptions"
                    @textChanged="onTariffTextChange"
                    @change="onTariffItemChange"
                    :filter="'contains'">
                </dynamic-dropdown>
                <!-- <autocomplete
                    v-model="item.tariffEntityToTariffItemId"
                    :defer-options-loading="false"
                    api="/api/Tariffs/SearchTariffItems"
                    hide-no-data
                    hide-selected
                    clearable
                    item-value="id"
                    item-text="text"
                /> -->
                <!-- <small v-if="selectedTariffText">{{selectedTariffText}}</small> -->
            </div>
            <div v-else>
                {{item.tariffEntityItem}}
            </div>
        </td>
        <td style="max-width: 400px;">
            <span style="font-size: 0.8rem;">
                {{ item.description }}
            </span>
        </td>
        <td class="minWidth-120" style="max-width: 140px; vertical-align: middle;">
            <date-picker
                :readonly="isLockedForEdit"
                v-model="item.date"
                :show-time="false"
                font-size="0.9rem">
            </date-picker>
        </td>
        <td class="numberColumnWidth" style="vertical-align: middle;">
            <div v-if="!isLockedForEdit">
                <input type="number" class="form-control" style="font-size: 0.9rem;" v-model="item.qty">
            </div>
            <div v-else>
                {{item.qty}}
            </div>
        </td>
        <td class="numberColumnWidth" style="vertical-align: middle;">
            <div v-if="!isLockedForEdit">
                <input type="number" class="form-control" style="font-size: 0.9rem;" v-model="item.price">
            </div>
            <div v-else>
                {{item.price}}
            </div>
        </td>
        <td class="numberColumnWidth" style="font-size: 0.8rem; font-weight: bold; vertical-align: middle;">{{ total }}</td>
        <td v-if="showFileUpload" style="max-width: 200px; vertical-align: middle;">
            <div v-if="!item.financialControl && !isLockedForEdit" class="text-center">
                <i class="pointer fas fa-upload text-primary"
                    data-toggle="tooltip"
                    :title="$t('buttons.add.tooltipText')"
                    @click="fileUploadClicked(index)"></i>
            </div>
            <div v-for="file in item.files" :key="file.id">
                <div v-if="loading" class="loader"></div>
                <div v-else>
                    <button v-if="file.id" class="btn btn-link btn-primary text-left m-0 p-0" style="font-size: 0.8em; display: inline-flex;" @click.stop="download(file)">
                        {{ file.fileName }}
                        <i v-if="!isLockedForEdit"
                            class="fas fa-minus-circle text-danger float-right pointer pl-1 pt-1"
                            data-toggle="tooltip"
                            :title="$t('buttons.delete.tooltipText')"
                           @click="removeFile(file)"></i>
                    </button>
                    <a v-else style="font-size: 0.8rem;" >{{ file.fileName }}</a>
                </div>
            </div>
        </td>
        <td style="vertical-align: middle; font-size: 0.7rem;">
            {{ item.lastUpdater }} / {{ $moment(item.lastUpdateDate).format('DD.MM.YYYY HH:mm') }}

        </td>
    </tr>
</template>

<script>
    import DynamicDropdown from '../dropdown/DynamicDropdown';
    import DatePicker from '../datepicker/DateTimePicker';
    import { BudgetPlanningRowModel } from '@/models/models';
    // import Autocomplete from '@/components/wrappers/CustomAutocomplete.vue';


    export default {
        props: {
            item: {
                type: BudgetPlanningRowModel,
                default: new BudgetPlanningRowModel()
            },
            showFileUpload: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            },
            showSyncButton: {
                type: Boolean,
                default: false
            },
            tariffOptions: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                baseUrl: this.$store.getters.baseUrl,
                selectedTariffText: '',
                tariffEntityToItems: [],
                loading: false,
            }
        },
        components: {
            DynamicDropdown,
            DatePicker,
            // Autocomplete
        },
        methods: {
            fileUploadClicked(index) {
                this.$emit('onItemUploadFilesClicked', index);
            },
            removeFile(file) {
                this.clickedItem();
                this.$emit('fileToBeRemoved', file);
            },
            clickedItem() {
                this.$emit('clickedItemIndex', this.index);
            },
            deleteItem() {
                this.$emit('deleteItem', this.index);
            },
            onTariffTextChange(text) {
                this.selectedTariffText = text;
                this.item.selectedTariffText = text;
            },
            download(file) {
                const downloadUri = this.$store.getters.baseUrl + `/api/file/download/?id=${file.id}&type=${file.docTypeCode}&hash=${file.hash}`;
                this.loading = true;

                this.$http.get(downloadUri, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data]);
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.fileName); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        })
                    })
                    .then(() => { this.loading = false; });
            },
            onTariffItemChange(val, item) {
                const tariffItem = Array.isArray(item) && item.length > 0 && item[0].hasOwnProperty('item') ? item[0].item : null;
                if (tariffItem) {
                    this.item.groupName = tariffItem.tariffName;
                    this.item.tariffEntityItemId = tariffItem.tariffItemId;
                    this.item.description = tariffItem.tariffItemDescription;
                    this.item.priceId = tariffItem.priceId
                    this.item.price = tariffItem.value
                } else {
                    this.item.groupName = null;
                    this.item.tariffEntityItemId = null;
                    this.item.description = null;
                    this.item.priceId = null
                    this.item.price = null
                }
            }
        },
        computed: {
            total() {
                const totalFinal = this.item.qty * this.item.price;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.item.total = totalFinal;
                this.$emit('totalChanged');
                return Math.round(totalFinal * 100) / 100;
            },
            hasDiffs() {
                return this.item && this.item.relatedExepense
                    && (this.item.qty !== this.item.relatedExepense.qty || this.item.price !== this.item.relatedExepense.price);
            }
        },
    }
</script>

<style lang="scss" scoped>
  ::v-deep {
    .minWidth-100 {
        min-width: 100px;
    }

    .minWidth-120 {
        min-width: 120px;
    }

    .minWidth-200 {
        min-width: 200px;
    }

    .minWidth-300 {
        min-width: 300px;
    }

    .minWidth-400 {
        min-width: 400px;
    }

    .minWidth-500 {
        min-width: 500px;
    }

    .minWidth-600 {
        min-width: 600px;
    }

    .numberColumnWidth {
        min-width: 90px;
        max-width: 110px;
    }

    span.k-input {
        font-size: 0.8rem !important;
    }

    .small-text{
        font-size: 0.6rem !important;
    }

    td {
        padding-top: 3px;
        padding-bottom: 3px;
    }
  }

  tr.has-diffs {
    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }
}
</style>


